/**
 * `/admin_clubs` (archive / reinstate venues) is restricted to the primary operator account.
 * Same email as inbox admin for now — see `inboxAdminAccess.js`.
 */
import { emailIsInboxAdmin } from './inboxAdminAccess.js';

export function emailIsClubsAdmin(email) {
  return emailIsInboxAdmin(email);
}
